// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'coa-foot-traffic-skeleton',
  templateUrl: './foot-traffic-skeleton.component.html',
  styleUrls: ['./foot-traffic-skeleton.component.scss'],
})
export class FootTrafficSkeletonComponent {
}
